import { setTerm } from './helpers';

export const setShowHotels = setTerm('show_hotels');
